<template>
  <div class="record">
    <div class="record-container">
      <div class="top-banner">
        <van-nav-bar 
          left-text="返回" 
          title="资源包充值"
          left-arrow 
          @click-left="onClickLeft"
        >
        </van-nav-bar>
        <van-tabs
          title-active-color="#ffffff" 
          title-inactive-color="#f0f0f0"
          v-model="activeTab"
          @change="tabChange"
        >
          <!-- <van-tab title="流量" name="traffic"></van-tab> -->
          <van-tab title="红包" name="red_pack"></van-tab>
          <!-- <van-tab title="短信" name="sms"></van-tab> -->
        </van-tabs>
      </div>
      <div class="content">
        <div class="price-list">
          <van-radio-group v-model="pid">
            <van-cell-group>
              <van-cell :key="p.id" clickable v-for="p in list" @click="choiceItem(p)">
                <template #title>
                  <div>规格：{{ p.value }} {{ item_unit[p.type] }}</div>
                  <div>价格：{{ p.price }}元</div>
                </template>
                <template #right-icon>
                  <van-radio :name="p.id" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <div class="charge-action" style="margin-top: 20px;">
            <van-button block round type="primary" @click="doCharge" style="width: 40vw">充值</van-button>
          </div>
        </div>
      </div>
    </div>
    <DisError />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import DisError from './component/DisError.vue';
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { getPriceList, makeChargeOrder } from '@/api/distributor'

export default {
  name: 'DisCharge',
  components: {
    Footer, DisError
  },
  data() {
    return {
      pid: undefined,
      cur_item: {id: undefined},
      page: 1,
      activeTab: 'red_pack',
      total_page: 0,
      list: [],
      meta: {
        type: 'red_pack',
        page: 1,
      },
    }
  },
  computed: {
    ...mapState(['user']),
    item_unit() {
      return {
        'red_pack': '元',
        'traffic': 'G',
        'sms': '条'
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    choiceItem(item) {
      // this.cur_item = item;
      this.pid = item.id;
    },
    init() {
      this.loadData()
    },
    tabChange(evt) {
      this.pid = undefined;
      this.loadData({
        type: evt,
      })
    },
    loadData({ type = 'red_pack' } = {}) {
      this.loadBusy = true;
      getPriceList(type, {}).then((resp) => {
        let { list } = resp.data
        this.list = list
        this.loadBusy = false
        this.meta = {
          type,
        }
      })
    },
    doCharge() {
      if (!this.pid) {
        return Toast('请先选择需要充值的资源')
      }
      makeChargeOrder(this.pid).then((ret) => {
        console.log(ret, ret.data);
        if ('data' in ret.data && 'tradeno' in ret.data.data) {
          location.href = window.__config__.cashier_url + '?tradeno=' + ret.data.data.tradeno
        }
      })
    },
    onClickLeft() {
      this.$router.back();
    },
  }
}
</script>
<style lang="scss" scoped>
.record-container {
  height: calc(100vh);
  width: 100%;
  display: flex;
  flex-direction: column;
  .top-banner {
    flex: 0 0 48px;
    background: #4fc08d;
  }
  .content {
    flex: 1 1 auto;
    width: 100%;
    overflow: hidden;
    background: #e3e3e3;
    .price-list {
      height: 100%;
      width: 100%;
      background: #fff;
      // background: red;
      overflow-y: scroll;
      padding: 10px;
      .charge-action {
        margin: 10px 0;
        display: flex;
        justify-content: center;
      }
    }
  }
}
.video_container {
  width: 90vw;
  height: 52vw;
  video {
    width: 100%;
  }
}
</style>
